module.exports = __webpack_public_path__ + "static/media/tommySleeveHood2.d23e05a5.svg";